import { Suspense } from 'react';

import { DOILoadReference } from '../reference/DOILoadReference';
import { Loading } from '../utils/Loading';
import { type OpenalexCitation } from './endpoints';

export interface CitedByListProps {
  citations?: {
    results: OpenalexCitation[];
    meta: any;
  };
}

export function CitedByList({ citations }: CitedByListProps) {
  if (!citations?.results.length) {
    return null;
  }

  const doiList = citations.results
    .map((value) => value.doi)
    .filter((doi): doi is string => !!doi)
    .filter((doi, index, self) => self.indexOf(doi) === index);

  return (
    <>
      {doiList.map((doi, index) => (
        <div key={doi} className={`p-2 ${index % 2 === 0 ? 'bg-light' : ''}`}>
          <Suspense fallback={<Loading />}>
            <DOILoadReference doi={doi} />
          </Suspense>
        </div>
      ))}
    </>
  );
}
